import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as firebase from 'firebase';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';
import IconButton from 'material-ui/IconButton';
import CloseIcon from 'material-ui-icons/Close';
import { CSSTransition } from 'react-transition-group'


const Fade = ({children, ...props}) => (
  <CSSTransition
    {...props}
    timeout={200}
    classNames="fade"
  >
    {children}
  </CSSTransition>
);

/**
 * receives paused,uid,sessionId, bid, strike, ask, and midPoints props from OrderBookContainer
 *
 * this component deals with rendering all of the strikes in the orderBook as well as
 * allowing users to enter limit orders and clear them.
 * This component also deals with highlighting the equilibrium bid and ask price
 */

class OrderBookRow extends Component {

    constructor(props) {
        console.log("OrderBookRow constructor");
        super(props);
        this.state = {
            askdata:0,
            biddata:0,
            firstRender: true,
    askQueue:[],
    bidQueue:[],
            queuePosition: "",
            midAskStyle: false,
            midBidStyle: false,
            placeholderBid: "",
            placeholderAsk: "",
            paused: this.props.paused
        };
    }

    /**
     * handles clearing orders, can only be invoked if transaction hasn't occurred
     * @param event
     */
    QueueData() { //I killed this... Andy
        this.state.askdata = 0;
        this.state.biddata = 0;
        this.valRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Assets").child("INTC").child("orderbook");
        //this.valRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Users").child(this.props.uid).child("Orders").child("INTC").child((this.props.Strike * 100).toFixed(0));
        this.valRef.on('value', snap => {
            //console.log("snap enter");
            let strikeValue;
            let orderType;
            let AheadValue;
            let rawData = snap.val();
            if(rawData) {
                for(var key in rawData) {
                    //console.log("raw enter");
                    var strikeVal = rawData[key];
                    for(var key1 in strikeVal) {
                        var trial =[];
                        //console.log(strikeVal[key1]);
                        var take1 = strikeVal[key1];
                        for(var ex in take1){
                        trial.push(take1[ex]);}
                        //console.log(trial);
                        for(var ex1 in trial){
                            var valType = trial[ex1];
                            if(valType.Type === "Bid") {
                                var bidVal = valType;
                               // console.log(bidVal);
                                    if(bidVal.UserId !== 0 && bidVal.UserId !== '0') {
                                        let x = {
                                            strikeValue : bidVal.Strike,
                                            orderType : bidVal.Type,
                                            AheadValue : bidVal.AheadOfThis
                                        };
                                        //console.log("Ahead bid "+x.AheadValue+" strike "+x.strikeValue);
                                        //this.state.biddata = AheadValue;
                                        this.state.bidQueue.push(x);
                                    }

                            } else if(valType.Type === "Ask") {
                                var askVal = valType;
                                if(askVal.UserId !== 0 && askVal.UserId !== '0'){
                                    let y = {
                                        strikeValue : askVal.Strike,
                                        orderType : askVal.Type,
                                        AheadValue : askVal.AheadOfThis
                                    };
                                    //console.log("Ahead ask " +y.AheadValue + " strike " + y.strikeValue);
                                    this.state.askQueue.push(y);

                                }
                            }
                        }
                    }
                }
            }
        });
        for(var j in this.state.askQueue){
            //console.log("aheadd ask " + this.state.askQueue[j].strikeValue)
            if(this.state.askQueue[j].strikeValue === (this.props.Strike * 100).toFixed(0) ){
                this.state.askdata = this.state.askQueue[j].AheadValue;
                console.log("aheadd ask " + this.state.askdata +" " + this.state.askQueue[j].strikeValue);
            }
        }
        for(var i in this.state.bidQueue){
            //console.log("aheadd bid " + this.state.bidQueue[i].strikeValue)
            if(this.state.bidQueue[i].strikeValue === (this.props.Strike * 100).toFixed(0) ){
                this.state.biddata = this.state.bidQueue[i].AheadValue;
                console.log("aheadd bid " + this.state.biddata +" " + this.state.bidQueue[i].strikeValue);
            }
        }
    }

    handleDeleteBid = (event) => {
        this.handleClear(event, 'userBidReset');
    }

    handleDeleteAsk = (event) => {
        this.handleClear(event, 'userAskReset');
    }

    handleClear = (event, type) => {
        //this.QueueData();
        console.log("OrderBookRow handleClear");
        event.persist();
        const ordersRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Users").child(this.props.uid).child("Orders").child("INTC").child((this.props.Strike * 100).toFixed(0));
        const deleteRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Users").child(this.props.uid).child("DeletesPending");
        ordersRef.once('value', snap => {
            let rawOrders = snap.val();
            if (rawOrders != null) {
                //console.log(rawOrders);
                let keys = Object.keys(rawOrders);
                for (var i = 0; i < keys.length; i++) {
                    console.log(rawOrders[keys[i]].Type, event);
                    if (rawOrders[keys[i]].Type === 'Bid' && type === 'userBidReset') {
                        //ordersRef.child(keys[i]).child("DeleteThis").set(true);
                        this.setState({
                            placeholderBid: ""
                        });
                        console.log("DELETING",this.props.Strike);
                        if (this.props.inAuction){
                          this.props.reportChange({strike: this.props.Strike, isUser: true, newValue: 0, orderType: "Bid"});
                        } else {
                          this.props.reportChange({strike: this.props.Strike, isUser: true, newValue: 0, orderType: "Bid", delay: true});
                        }
                        let newKey = deleteRef.push();
                        newKey.set(rawOrders[keys[i]]);
                        console.log('SHOULD HAVE SET');
                    } else if (rawOrders[keys[i]].Type === 'Ask' && type === 'userAskReset') {
                        //ordersRef.child(keys[i]).child("DeleteThis").set(true);
                        this.setState({
                            placeholderAsk: ""
                        });
                        if (this.props.inAuction){
                          this.props.reportChange({strike: this.props.Strike, isUser: true, newValue: 0, orderType: "Ask"});
                        } else {
                          this.props.reportChange({strike: this.props.Strike, isUser: true, newValue: 0, orderType: "Ask", delay: true});
                        }
                        let newKey = deleteRef.push();
                        newKey.set(rawOrders[keys[i]]);
                        console.log('SHOULD HAVE SET');
                    }
                }
            }
        });
    };

    //handles entering limit orders
    handleKeyUp = (event) => {
        //this.QueueData();
        console.log("OrderBookRow handleKeyUp", event);
        const ordersPendingRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Users").child(this.props.uid).child("OrdersPending");
        //various checks to validate input
        if (event.key === 'Enter') {
            if (event.target.value != null && !isNaN(event.target.value) && event.target.value % 1 === 0) {
                var volumeInt = parseInt(event.target.value, 10);
                if (volumeInt > 0 && volumeInt <= 999) {
                    if (event.target.name === 'userBid') {
                        //checks if order is a bid then sets
                        //to OrdersPending
                        let order = {
                            AheadOfThis: 0,
                            OrderId: -1,
                            UserId: this.props.uid,
                            Type: event.target.getAttribute("data-type"),
                            Volume: volumeInt,
                            AssetId: "INTC",
                            Strike: (this.props.Strike * 100).toFixed(0),
                            Class: "Limit",
                            AuctionOnly: this.props.isAuctionOnly

                        };
                        console.log(order);
                        event.target.value = "";
                        let newOrderRef = ordersPendingRef.push();
                        newOrderRef.set(order);
                    } else {
                        //if order is a bid then sets
                        //to OrdersPending
                        let order = {
                            AheadOfThis: 0,
                            OrderId: -1,
                            UserId: this.props.uid,
                            Type: event.target.getAttribute("data-type"),
                            Volume: volumeInt,
                            AssetId: "INTC",
                            Strike: (this.props.Strike * 100).toFixed(0),
                            Class: "Limit",
                            AuctionOnly: this.props.isAuctionOnly
                        };
                        console.log(order);
                        event.target.value = "";
                        let newOrderRef = ordersPendingRef.push();
                        newOrderRef.set(order);

                    }
                } else {
                    alert("You must enter a number between 0 and 999");
                    event.target.value = "";
                }
            } else {
                alert("You must enter a valid whole number");
                event.target.value = "";
            }
        }

    };

    componentDidMount() {
        //this.QueueData();
        this.aheadRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Users").child(this.props.uid).child("Orders").child("INTC").child((this.props.Strike * 100).toFixed(0));
        var that = this;
        this.aheadRef.on('value', snap => {
            //this listener attemps to loop through orders
            //and determind total order volume at that Strike
            //as well as ahead of this(needs work)
            if (!!snap.val()) {
                console.log("found user orders");
                let rawData = snap.val();
                //console.log(rawData);
                let aheadkey = Object.keys(rawData)[Object.keys(rawData).length - 1];
                //console.log(aheadkey);
                let ahead = rawData[aheadkey].AheadOfThis || '';
                //console.log("ahead" + ahead);
                let vol = 0;
                let keys = Object.keys(rawData);
                for (let i = 0; i < keys.length; i++) {
                    vol += parseInt(rawData[keys[i]].Volume);
                }
                //console.log(vol, ahead);
                if (rawData[aheadkey].Type === 'Bid' && vol > 0) {
                    that.setState({
                        placeholderBid: `${vol}`,
                        placeholderAsk: "",
                        queuePosition: ahead,
                    });
                } else {
                  if (vol > 0){
                    that.setState({
                        placeholderBid: "",
                        placeholderAsk: `${vol}`,
                        queuePosition: ahead,
                    });
                  }
                }
                if (this.props.inAuction){
                  this.props.reportChange({strike: this.props.Strike, isUser: true, newValue: vol, orderType: rawData[aheadkey].Type});
                } else {
                  this.props.reportChange({strike: this.props.Strike, isUser: true, newValue: vol, orderType: rawData[aheadkey].Type, delay: true});
                }
            } else {
                that.setState({
                    placeholderBid: "",
                    placeholderAsk: ""
                })
                if (this.props.inAuction){
                  this.props.reportChange({strike: this.props.Strike, isUser: true, newValue: 0, orderType: "Bid"});
                  this.props.reportChange({strike: this.props.Strike, isUser: true, newValue: 0, orderType: "Ask"});
                } else {
                  this.props.reportChange({strike: this.props.Strike, isUser: true, newValue: 0, orderType: "Bid", delay: true});
                  this.props.reportChange({strike: this.props.Strike, isUser: true, newValue: 0, orderType: "Ask", delay: true});
                }
            }
        })




    }

    componentWillUnmount() {
        console.log("OrderBookRow componentWillUnmount");
        this.aheadRef.off();
    }

    componentWillReceiveProps(nextProps) {
        //this.QueueData();
        /*if(this.theInput && nextProps.StartCenter){
          console.log(this.props.Strike, this.theInput);
          this.theInput.scrollIntoView();
          setTimeout(nextProps.WasScrolled, 0);
        }*/

        if (nextProps.Bid !== this.props.Bid){
          this.fadeBid = true;
        } else {
          this.fadeBid = false;
        }

        if (nextProps.Ask !== this.props.Ask){
          this.fadeAsk = true;
          console.log("fadeAsk...");
        } else {
          this.fadeAsk = false;
        }


        if (nextProps.paused === true) {
            //console.log("paused:", nextProps.paused);
            this.setState({
                paused: false,
                firstRender: false
            });
        } else {
            //console.log("else paused:", nextProps.paused);
            this.setState({
                paused: false,
                firstRender: false
            });
        }

    }


    render() {
        // console.log("askobject " +this.state.askobj);
        //this.QueueData();

        //var strike1 = (this.props.Strike * 100).toFixed(0);
        return (
            <TableRow className={`orderBookRow ${this.props.highlight ?  'highlight' : ''}`}>
                <TableCell className='orderBookCell bidInput'>
                    <IconButton disabled={this.state.paused}
                     onClick={this.handleDeleteBid} className="btn-danger bidReset"
                     name="userBidReset"
                     type="reset"
                     size="1"
                    >
                      <CloseIcon/>
                    </IconButton>
                    <input
                        disabled={this.state.paused}
                        onKeyUp={this.handleKeyUp}
                        data-type="Bid"
                        name="userBid"
                        className="userBid"
                        type="text"
                        size="4"
                        placeholder={!this.props.inAuction ? (!!this.state.placeholderBid ? this.state.placeholderBid : '') : this.props.auctionUserBid}
                        ref={(input)=>{this.theInput = input; }}
                        autoComplete="off"
                    />
                </TableCell>
                <Fade in={!!this.fadeBid}>
                <TableCell className={`bid orderBookCell ${!!this.props.Bid ? 'textBid' : 'emptyBid'}`}>
                    {this.props.Bid}
                </TableCell>
                </Fade>

                <TableCell className='strike textStrike orderBookCell'>
                    {this.props.Strike}
                </TableCell>

                <Fade in={!!this.fadeAsk}>
                <TableCell className={`ask orderBookCell ${!!this.props.Ask ? 'textBid' : 'emptyBid'}`}>
                    {this.props.Ask}
                </TableCell>
                </Fade>

                <TableCell className='orderBookCell askInput'>
                    <input
                        disabled={this.state.paused}
                        onKeyUp={this.handleKeyUp}
                        data-type="Ask"
                        className="userAsk"
                        type="text"
                        size="4"
                        autoComplete="off"
                        placeholder={!this.props.inAuction ? (!!this.state.placeholderAsk ? this.state.placeholderAsk : '') : this.props.auctionUserAsk}
                    />
                    <IconButton disabled={this.state.paused}
                     onClick={this.handleDeleteAsk} className="btn-danger askReset"
                     name="userAskReset"
                     type="reset"
                     size="1"
                    >
                      <CloseIcon/>
                    </IconButton>
                </TableCell>
            </TableRow>
        );
    }
}

OrderBookRow.propTypes = {
    sessionid: PropTypes.string,
    uid: PropTypes.string,
    Bid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    Ask: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    Strike: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default OrderBookRow;



// WEBPACK FOOTER //
// ./src/components/Orderbook/OrderBookRow.js